/** 
* @description 数据管理的基础库 跨框架使用的 数据管理获取 
* @version 0.3.1 
* @author lengyingxin <lengyingxin8966@gmail.com> (https://github.com/LengYXin)
*/
import _findIndex from 'lodash/findIndex';
import _map from 'lodash/map';
import _isObject from 'lodash/isObject';
import _omit from 'lodash/omit';
import _unset from 'lodash/unset';
import _toInteger from 'lodash/toInteger';
import _compact from 'lodash/compact';
import _isEqual from 'lodash/isEqual';
import _keys from 'lodash/keys';
import _pick from 'lodash/pick';
import _isEmpty from 'lodash/isEmpty';
import _size from 'lodash/size';
import _includes from 'lodash/includes';
import _isArray from 'lodash/isArray';
import _get from 'lodash/get';
import _isFunction from 'lodash/isFunction';
import _eq from 'lodash/eq';
import _set from 'lodash/set';
import _cloneDeep from 'lodash/cloneDeep';
import _last from 'lodash/last';
import _head from 'lodash/head';
import _assign from 'lodash/assign';
import _isString from 'lodash/isString';
import _merge from 'lodash/merge';
import { __awaiter, __generator, __decorate } from 'tslib';
import { BindAll } from 'lodash-decorators';
import { computed, toJS } from 'mobx';
import { filter, concatMap, of } from 'rxjs';
import { AjaxBasics } from '../helpers';
import { BaseModel } from './baseModel';
import { EnumBasesKeys, EnumActionKeys, BasesOptions } from './basesOptions';
import { BasesUtils } from './basesUtils';

/**
 * 基础 分页管理
 */

var BasesPagination =
/** @class */
function () {
  /**
   * 基础 分页列表数据
   * @param {IBasesPaginationOptions} [options]
   * @memberof BasesPagination
   */
  function BasesPagination(options) {
    /**
     * 配置信息
     * @type {IBasesPaginationOptions}
     * @memberof BasesPagination
     */
    this.options = {};
    this.Model = new BaseModel(_merge({
      type: 'list'
    }, options === null || options === void 0 ? void 0 : options.listModel));
    this.reset(options);
  }

  Object.defineProperty(BasesPagination.prototype, "defaultOptions", {
    /**
     * 默认的分页参数配置
     * @type {IBasesPaginationOptions}
     * @memberof BasesPagination
     */
    get: function get() {
      return {
        pagination: BasesOptions.pagination,
        paginationParams: BasesOptions.paginationParams,
        infinite: BasesOptions.infinite
      };
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BasesPagination.prototype, "AjaxConfig", {
    /**
     * AjaxConfig
     * @readonly
     * @memberof lodash.assign(basesOptions.pagination,this.options.pagination)
     */
    get: function get() {
      var pagination = this.options.pagination;

      if (_isString(pagination)) {
        pagination = {
          url: this.options.pagination
        };
      }

      return _assign({
        target: this.options.target
      }, this.defaultOptions.pagination, pagination);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BasesPagination.prototype, "PaginationParams", {
    /**
     * Pagination 参数配置
     * @readonly
     * @memberof lodash.assign(...)
     */
    get: function get() {
      return _merge({}, this.defaultOptions.paginationParams, this.options.paginationParams);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BasesPagination.prototype, "timestamp", {
    /**
     * 当前请求的 生成时间戳
     * @readonly
     * @memberof [Model.getStorage(timestamp])]
     */
    get: function get() {
      return this.Model.getStorage(EnumBasesKeys.timestamp);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BasesPagination.prototype, "loading", {
    /**
     * 当前请求的 加载状态
     * @readonly
     * @memberof [Model.loading)]
     */
    get: function get() {
      return this.Model.loading;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BasesPagination.prototype, "request", {
    /**
     * 请求的参数值 [AjaxConfig]
     * @readonly
     * @memberof [Model.getStorage(request])]
     */
    get: function get() {
      return this.Model.getStorage(EnumBasesKeys.request);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BasesPagination.prototype, "finished", {
    /**
     * 是否已加载完成，加载完成后不再触发
     * @readonly
     * @memberof BasesPagination
     */
    get: function get() {
      return this.Model.getStorage(EnumBasesKeys.finished, false);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BasesPagination.prototype, "requestError", {
    /**
     * 请求出错
     * @readonly
     * @memberof BasesPagination
     */
    get: function get() {
      return this.Model.getStorage(EnumBasesKeys.requestError, false);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BasesPagination.prototype, "total", {
    /**
     * 当前请求的 数据总数
     * @readonly
     * @memberof [Model.getStorage(response[PaginationParams.response.total])]
     */
    get: function get() {
      return this.Model.getStorage(EnumBasesKeys.response + ".total", 0);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BasesPagination.prototype, "current", {
    /**
     * 当前请求的 页码索引
     * @readonly
     * @memberof [Model.getStorage(request.body[PaginationParams.currentKey])]
     */
    get: function get() {
      var PaginationParams = this.PaginationParams;
      return this.Model.getStorage(EnumBasesKeys.request + ".body." + PaginationParams.currentKey, PaginationParams.defaultCurrent);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BasesPagination.prototype, "pageSize", {
    /**
     * 分页请求的 每页条数
     * @readonly
     * @memberof [Model.getStorage(request.body[PaginationParams.pageSizeKey])]
     */
    get: function get() {
      var PaginationParams = this.PaginationParams;
      return this.Model.getStorage(EnumBasesKeys.request + ".body." + PaginationParams.pageSizeKey, PaginationParams.defaultPageSize);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BasesPagination.prototype, "oldBody", {
    /**
     * 旧的 请求参数
     * @readonly
     * @memberof BasesPagination
     */
    get: function get() {
      if (this.PaginationParams.filterKey) {
        return this.Model.getStorage(EnumBasesKeys.request + ".body." + this.PaginationParams.filterKey);
      }

      return this.Model.getStorage(EnumBasesKeys.request + ".body");
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BasesPagination.prototype, "dataSource", {
    /**
     * 分页数据 value
     * @readonly
     * @memberof [Model.value]
     */
    get: function get() {
      return this.Model.value;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BasesPagination.prototype, "firstData", {
    /** 第一个元素 */
    get: function get() {
      return toJS(_head(this.Model.obsValue));
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BasesPagination.prototype, "lastData", {
    /** 最后一个元素 */
    get: function get() {
      return toJS(_last(this.Model.obsValue));
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BasesPagination.prototype, "selectedRowKeys", {
    /**
     * 选择的行 Keys
     * @readonly
     * @memberof BasesPagination
     */
    get: function get() {
      return this.getEntitys(this.selectedRow);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BasesPagination.prototype, "selectedRow", {
    /**
     * 选择的行
     * @readonly
     * @memberof BasesPagination
     */
    get: function get() {
      return this.Model.getStorage(EnumBasesKeys.selectedRow, []);
    },
    enumerable: false,
    configurable: true
  });
  /**
   * 重置 配置
   * @param options
   */

  BasesPagination.prototype.reset = function (options) {
    if (options === void 0) {
      options = _cloneDeep(this.options);
    } // if (this.loading) {
    //     return BasesUtils.warning(`Pagination reset loading 未完成`);
    // }


    _assign(this.options, this.defaultOptions, options);

    this.clear();
    return this;
  };
  /**
   * 加载数据
   * @param AjaxConfig
   */

  BasesPagination.prototype.onLoad = function (AjaxConfig) {
    return __awaiter(this, void 0, void 0, function () {
      var timestamp_1, obs, response, error_1;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            if (this.loading) {
              throw "loading";
            }

            if (this.options.infinite && this.finished) {
              throw 'finished';
            }

            timestamp_1 = Date.now();
            this.Model.toggleLoading(true);
            this.Model.setStorage(EnumBasesKeys.timestamp, timestamp_1);
            AjaxConfig = this.createAjaxConfig(AjaxConfig);

            _set(AjaxConfig, 'headers.timestamp', timestamp_1);

            BasesUtils.log("Pagination onLoad " + timestamp_1, AjaxConfig);
            obs = AjaxBasics.requestObservable(AjaxConfig).pipe( // 过滤过期请求
            filter(function () {
              if (_eq(timestamp_1, _this.timestamp)) {
                return true;
              }

              BasesUtils.warning(EnumActionKeys.pagination + (" " + timestamp_1 + " \u8FC7\u671F > " + _this.timestamp + " \u6700\u65B0 "));
            }), // 格式化返回数据
            concatMap(function (response) {
              var _a = _this.PaginationParams.response,
                  valueGetter = _a.valueGetter,
                  dataSource = _a.dataSource,
                  total = _a.total,
                  current = _a.current,
                  pageSize = _a.pageSize;

              if (_isFunction(valueGetter)) {
                var res = valueGetter(response, AjaxConfig);

                if (res instanceof Promise) {
                  return res;
                }

                return of(res);
              }

              return of({
                current: _get(response, current),
                pageSize: _get(response, pageSize),
                total: _get(response, total),
                dataSource: _isArray(response) ? response : _get(response, dataSource, [])
              });
            }));
            return [4
            /*yield*/
            , AjaxBasics.toPromise(obs, AjaxConfig)];

          case 1:
            response = _a.sent();
            this.set(response);
            return [2
            /*return*/
            , response];

          case 2:
            error_1 = _a.sent();

            if (!_includes(['loading', 'finished'], error_1)) {
              this.Model.toggleLoading(false);
              this.Model.setStorage(EnumBasesKeys.finished, true);
              this.Model.setStorage(EnumBasesKeys.requestError, true);
              BasesUtils.error(EnumActionKeys.pagination, error_1, this);
              throw error_1;
            } else {
              console.warn(error_1, this);
            }

            return [3
            /*break*/
            , 3];

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * 刷新当前参数数据
   * @memberof BasesPagination
   */


  BasesPagination.prototype.onRemoteRefresh = function () {
    return this.onLoad({
      body: this.oldBody
    });
  };
  /**
   * 设置 response 数据
   * @param {IBasesResponse} response
   * @memberof BasesPagination
   */


  BasesPagination.prototype.set = function (response) {
    if (response) {
      BasesUtils.log("Pagination Set " + this.timestamp, response, this);
      this.Model.setStorage(EnumBasesKeys.requestError, false);
      this.Model.setStorage(EnumBasesKeys.response, response);

      var size = _size(response.dataSource);

      this.Model.setStorage(EnumBasesKeys.finished, size < this.pageSize); // if (size) {

      if (this.options.infinite && size) {
        this.Model.insert(response.dataSource);
      } else if (_isArray(response.dataSource)) {
        this.Model.set(response.dataSource);
      } // }


      if (!this.finished && response.total) {
        this.Model.setStorage(EnumBasesKeys.finished, _eq(this.total, this.Model.size));
      }
    }

    this.Model.toggleLoading(false);
    return response;
  };
  /**
  * 清理数据
  */


  BasesPagination.prototype.clear = function () {
    this.Model.toggleLoading(false);
    this.Model.set([]);
    this.Model.clearStorage();
  };
  /**
   * 选择行数据
   * @param selectedRow
   */


  BasesPagination.prototype.onSelectChange = function (selectedRow) {
    BasesUtils.log("Pagination selectedRow", selectedRow);
    this.Model.setStorage(EnumBasesKeys.selectedRow, selectedRow);
  };
  /**
   * 对比请求参数是否相同请求参数
   * @param {*} other
   * @return {*}
   * @memberof BasesPagination
   */


  BasesPagination.prototype.eqRequestBody = function (other) {
    var body = _get(this.request, 'body', {});

    if (_isEmpty(body) || this.Model.size === 0) {
      return false;
    }

    if (this.PaginationParams.filterKey) {
      body = _get(body, this.PaginationParams.filterKey);
    }

    body = _pick(body, _keys(other));
    return _isEqual(body, other);
  };
  /**
   * 创建 onLoad AjaxConfig
   * @param AjaxConfig
   * @returns
   */


  BasesPagination.prototype.createAjaxConfig = function (AjaxConfig) {
    var Pagination = this.PaginationParams;
    AjaxConfig = _merge({}, this.AjaxConfig, AjaxConfig);

    var currentKey = "body." + this.PaginationParams.currentKey,
        pageSizeKey = "body." + this.PaginationParams.pageSizeKey,
        filterKey = "body." + this.PaginationParams.filterKey,
        current = _head(_compact([// body 中的 current
    _get(AjaxConfig, currentKey), // AjaxConfig 中的 current
    _get(AjaxConfig, 'current'), // 当前使用 中的 current
    this.current, // 默认 的 current
    Pagination.defaultCurrent])),
        pageSize = _head(_compact([// body 中的 pageSize
    _get(AjaxConfig, pageSizeKey), // AjaxConfig 中的 pageSize
    _get(AjaxConfig, 'pageSize'), // 当前使用 中的 pageSize
    this.pageSize, // 默认 的 pageSize
    Pagination.defaultPageSize])); // 无限滚动模式


    if (this.options.infinite) {
      var infiniteKey = "body." + this.PaginationParams.infiniteKey;
      var lastKey = this.getDataKey(this.lastData);

      _set(AjaxConfig, infiniteKey, lastKey); // 存在参数 页码加一


      if (lastKey) {
        current += 1;
      }
    }

    if (current) {
      _set(AjaxConfig, currentKey, _toInteger(current));
    }

    if (pageSize) {
      _set(AjaxConfig, pageSizeKey, _toInteger(pageSize));
    }

    _unset(AjaxConfig, 'current');

    _unset(AjaxConfig, 'pageSize');

    if (this.PaginationParams.filterKey) {
      var body = _cloneDeep(AjaxConfig.body);

      _set(AjaxConfig, 'body', _pick(body, [this.PaginationParams.currentKey, this.PaginationParams.pageSizeKey]));

      _set(AjaxConfig, filterKey, _omit(body, [this.PaginationParams.currentKey, this.PaginationParams.pageSizeKey]));
    }

    this.Model.setStorage(EnumBasesKeys.request, _cloneDeep(AjaxConfig));
    return AjaxConfig;
  };
  /**
   * 获取 当前数据的 Key
   * @param entity 数据对象
   * @param predicate lodash predicate 参数 [dataKey,**]
   * @returns dataKey
   */


  BasesPagination.prototype.getDataKey = function (entity, predicate) {
    if (predicate === void 0) {
      predicate = false;
    }

    if (!_isObject(entity)) {
      return entity;
    }

    var dataKey = this.options.dataKey;

    var key = _get(entity, this.options.dataKey);

    if (predicate) {
      return [dataKey, key];
    }

    return key;
  };
  /**
   * 解析 Array<entity...> 为 对应的 Array<dataKey...>
   * @param entitys
   * @returns
   */


  BasesPagination.prototype.getEntitys = function (entitys) {
    var _this = this;

    if (_isArray(entitys)) {
      entitys = _map(entitys, function (item) {
        if (_isObject(item)) return _this.getDataKey(item);
        return item;
      });
    } else {
      entitys = [_isObject(entitys) ? this.getDataKey(entitys) : entitys];
    }

    return entitys;
  };
  /**
   * 插入数据到 Model 中
   * @param {(T | Array<T>)} entity
   * @memberof BasesPagination
   * @returns entity
   */


  BasesPagination.prototype.onInsert = function (entitys, first) {
    if (first === void 0) {
      first = false;
    }

    if (_isEmpty(entitys) || !_isObject(entitys)) {
      return entitys;
    }

    this.Model.insert(entitys, first);
    return entitys;
  };
  /**
   * 修改数组中的对象 根据 entity.dataKey 匹配
   * @param entity 新的数据对象 dataKey 匹配集合中的对应数据
   * @param assign 是否 assign 模式
   * @returns entity
   */


  BasesPagination.prototype.onUpdate = function (entity, assign) {
    if (assign === void 0) {
      assign = true;
    }

    var path = _findIndex(this.Model.obsValue, this.getDataKey(entity, true));

    if (_eq(path, -1)) {
      return;
    }

    return this.Model.update(function (old) {
      if (assign) return _assign(old, entity);
      return entity;
    }, "[" + path + "]");
  };
  /**
   * 删除数组中的对象 根据 entity.dataKey 匹配
   * @param entitys  dataKey 匹配集合中的对应数据 entity | entity.dataKey | Arrar<entity> | Arrar<entity.dataKey>
   * @returns 返回移除元素组成的新数组。
   */


  BasesPagination.prototype.onDelete = function (entitys) {
    var _this = this;

    return this.Model["delete"](function (item) {
      return _includes(_this.getEntitys(entitys), _this.getDataKey(item));
    });
  };

  __decorate([computed], BasesPagination.prototype, "timestamp", null);

  __decorate([computed], BasesPagination.prototype, "loading", null);

  __decorate([computed], BasesPagination.prototype, "request", null);

  __decorate([computed], BasesPagination.prototype, "finished", null);

  __decorate([computed], BasesPagination.prototype, "requestError", null);

  __decorate([computed], BasesPagination.prototype, "total", null);

  __decorate([computed], BasesPagination.prototype, "current", null);

  __decorate([computed], BasesPagination.prototype, "pageSize", null);

  __decorate([computed], BasesPagination.prototype, "oldBody", null);

  __decorate([computed], BasesPagination.prototype, "dataSource", null);

  __decorate([computed], BasesPagination.prototype, "firstData", null);

  __decorate([computed], BasesPagination.prototype, "lastData", null);

  __decorate([computed], BasesPagination.prototype, "selectedRowKeys", null);

  __decorate([computed], BasesPagination.prototype, "selectedRow", null);

  BasesPagination = __decorate([BindAll()], BasesPagination);
  return BasesPagination;
}();

export { BasesPagination };
//# sourceMappingURL=basesPagination.js.map
